module.exports = __webpack_public_path__ + "media/images/icons/outlined/close-square-b444e8dc55a25fcb729a81af8fab12b1.svg";